class AlertaFilter {
    constructor($filter, $scope) {
        this.filter = {}
        this.$filter = $filter

        this.tiposAlertas = [
            {codigo: 'NCM_DIVERGENTE', descricao: 'NCM divergente'},
            {codigo: 'MEDICAMENTO_VENCENDO', descricao: 'Medicamento vencendo'},
            {codigo: 'NFE_CANCELADA', descricao: 'NF-e cancelada'},
            {codigo: 'NFE_SNA', descricao: 'NF-e Simples Nacional'},
            {codigo: 'NFE_SNA_SEM_CREDITO_DESTACADO', descricao: 'NF-e SNA sem crédito destacado'},
            {codigo: 'ITEM_SEM_CEST', descricao: 'Item sem especificação da CEST'},
            {codigo: 'CEST_DIVERGENTE', descricao: 'Item com CEST divergente'}
        ]

        this.statusRevisao = [
            {codigo: 'NAO_REVISADO', descricao: 'Não revisado'},
            {codigo: 'REVISADO', descricao: 'Revisado'},
            {codigo: 'ANALISE', descricao: 'Em análise'}
        ]

        $scope.$watch(() => this.filter, () => {
            if(this.updateStatusWhereEvent) {
                delete this.updateStatusWhereEvent
            } else {
                this.submit()
            }
        }, true)

        $scope.$watch(() => this.empresa, () => {
            this.submit()
        })

        $scope.$on('updateStatusWhere', (_event, status) => {
            this.updateStatusWhereEvent = true
            this.filter.revisaoStatus = status
        })
    }

    $onInit() {
        this.ngModelCtrl.$render = () => {
            if(this.ngModelCtrl.$viewValue) {
                this.filter = this.ngModelCtrl.$viewValue
            }
        }

        this.filter.revisaoStatus = 'NAO_REVISADO'
        this.filter.tipoEmissao = 'TERCEIROS'
    }

    submit() {
        if (this.form.$valid) {
            this.updateFilter()
        }
    }

    async updateFilter() {
        let filter = angular.copy(this.filter)
        cbk.deleteEmptyKeys(filter)

        if(this.empresa) filter.empresaId = this.empresa.id

        if (filter.periodo) {
            if (filter.periodo.inicial)
                filter.emissaoInicial = filter.periodo.inicial.toISOString()

            if (filter.periodo.final)
                filter.emissaoFinal = filter.periodo.final.toISOString()
        }

        delete filter.periodo

        if (filter.numero) {
            delete filter.emissaoInicial
            delete filter.emissaoFinal
        }

        this.ngModelCtrl.$setViewValue(filter)
    }
}

angular.module('eficienciaFiscalModule')
    .component('alertaFilter', {
        controller: ['$filter', '$scope', AlertaFilter],
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            contratoId: '<',
            onChange: '&'
        },
        template: `
        <form class="fade-animation" name="$ctrl.form" ng-submit="$ctrl.submit()">
            <div class="row">
                <ef-empresa-selector
                    class="col-xs-12"
                    name="empresa"
                    ng-model="$ctrl.empresa"
                    contrato-id="$ctrl.contratoId"
                    ferramenta="central-alertas"
                    cache-as="central-alertas"
                    required>
                </ef-empresa-selector>
                <div class="form-group col-sm-6 col-lg-4">
                    <label>
                        Data de emissão
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.periodo = undefined"
                           ng-if="$ctrl.filter.periodo.inicio || $ctrl.filter.periodo.fim"></i>
                    </label>
                    <periodo-input ng-model="$ctrl.filter.periodo"></periodo-input>
                </div>
                <div class="form-group col-sm-3 col-lg-2">
                    <label>
                        Tipo de emissão
                    </label>
                    <select class="form-control" ng-model="$ctrl.filter.tipoEmissao">
                        <option value="PROPRIA">Emitidas</option>
                        <option value="TERCEIROS">Recebidas</option>
                    </select>
                </div>
                <div class="form-group col-sm-3 col-lg-2">
                    <label>
                        Número NF-e
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.numero = undefined"
                           ng-if="$ctrl.filter.numero"></i>
                    </label>
                    <input type="text" class="form-control" ng-model="$ctrl.filter.numero" ng-model-options="{ debounce: 500 }">
                </div>
                <div class="form-group col-sm-4 col-md-4 col-lg-4">
                    <label>
                        Razão Social, CNPJ
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.emitente = undefined"
                           ng-if="$ctrl.filter.emitente"></i>
                    </label>
                    <input type="text" class="form-control" ng-model="$ctrl.filter.emitente" ng-model-options="{ debounce: 500 }">
                </div>
                <div class="form-group col-sm-3 col-md-3 col-lg-3">
                    <label>
                        Tipo do alerta
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.tipoAlerta = undefined"
                           ng-if="$ctrl.filter.tipoAlerta != undefined"></i>
                    </label>
                    <select class="form-control" ng-model="$ctrl.filter.tipoAlerta">
                        <option ng-value="undefined">...</option>
                        <option ng-repeat="tipo in $ctrl.tiposAlertas" value="{{ tipo.codigo }}">
                            {{ tipo.descricao }}
                        </option>
                    </select>
                </div>
                <div class="form-group col-sm-3 col-md-3 col-lg-3">
                    <label>
                        Status da revisão
                        <i class="fa fa-trash-o text-danger cursor-pointer" 
                           ng-click="$ctrl.filter.revisaoStatus = undefined"
                           ng-if="$ctrl.filter.revisaoStatus != undefined"></i>
                    </label>
                    <select class="form-control" ng-model="$ctrl.filter.revisaoStatus">
                        <option ng-value="undefined">...</option>
                        <option ng-repeat="status in $ctrl.statusRevisao" value="{{ status.codigo }}">
                            {{ status.descricao }}
                        </option>
                    </select>
                </div>
                <div class="form-group col-sm-2 col-lg-2">
                    <label for="" class="hidden-xs">&nbsp;</label>
                    <button type="submit" class="btn btn-primary btn-block"><i class=" fa fa-refresh"></i> Atualizar</button>
                </div>
            </div>
        </form>
        `
    })
